var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 10 6.437",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6.437\" id=\"arrow-up\">\n  <path id=\"arrow-up_Pfeil_oben\" class=\"cls-1\" d=\"M1400.53,473.531a0.723,0.723,0,0,0-.53-0.218,0.707,0.707,0,0,0-.53.218l-4.25,4.25a0.752,0.752,0,0,0,0,1.063l0.72,0.687a0.708,0.708,0,0,0,.53.219,0.724,0.724,0,0,0,.53-0.219l3-3,3.03,3a0.63,0.63,0,0,0,.5.219,0.708,0.708,0,0,0,.53-0.219l0.72-.687a0.752,0.752,0,0,0,0-1.063Z\" transform=\"translate(-1395 -473.313)\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id